import { render, staticRenderFns } from "./ItemsKitDinamico.vue?vue&type=template&id=247d2878"
import script from "./ItemsKitDinamico.vue?vue&type=script&lang=ts"
export * from "./ItemsKitDinamico.vue?vue&type=script&lang=ts"
import style0 from "./ItemsKitDinamico.vue?vue&type=style&index=0&id=247d2878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports